var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * 表单字段数据，字段错误，校验器
 * @author georgemo
 */
import { useCallback, useRef } from 'react';
import useObject from './useObject';
import Validator from 'async-validator';
import equal from 'fast-deep-equal';
export function createUseFormData(initialValues, scrollWithErrors) {
    if (initialValues === void 0) { initialValues = {}; }
    return function useFormData() {
        var _a = __read(useObject(initialValues), 2), values = _a[0], setValues = _a[1];
        var _b = __read(useObject({}), 2), errors = _b[0], setError = _b[1];
        var rulesRef = useRef({});
        var rules = rulesRef.current;
        var initialValuesRef = useRef(__assign({}, initialValues));
        // 当某些 Field 的值不是直接取自values里面的某个字段，而是用多个字段自由组合的时候，需要另外存起来，后面校验时候需要用到
        var validateValuesRef = useRef({});
        var validateValues = validateValuesRef.current;
        // 检查 Field 是否发生过修改
        var touchedStateRef = useRef({});
        var setTouchedState = function (field, value) {
            touchedStateRef.current[field] = value;
        };
        var resetErrors = useCallback(function () {
            setError(function (errs) {
                var e_1, _a;
                try {
                    for (var _b = __values(Object.keys(errs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var key = _c.value;
                        delete errs[key];
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        }, [setError]);
        var removeError = useCallback(function (field) {
            setError(function (errs) {
                delete errs[field];
            });
        }, [setError]);
        var removeErrors = useCallback(function (fields) {
            setError(function (errs) {
                var e_2, _a;
                try {
                    for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                        var field = fields_1_1.value;
                        delete errs[field];
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        }, [setError]);
        var removeValue = useCallback(function (field) {
            setValues(function (values) {
                delete values[field];
            });
        }, [setValues]);
        var removeValues = useCallback(function (fields) {
            setValues(function (values) {
                var e_3, _a;
                try {
                    for (var fields_2 = __values(fields), fields_2_1 = fields_2.next(); !fields_2_1.done; fields_2_1 = fields_2.next()) {
                        var field = fields_2_1.value;
                        delete values[field];
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (fields_2_1 && !fields_2_1.done && (_a = fields_2.return)) _a.call(fields_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            });
        }, [setValues]);
        var resetValues = useCallback(function (vs) {
            if (vs === void 0) { vs = initialValuesRef.current; }
            var obj = vs;
            setValues(function (values) {
                var e_4, _a;
                try {
                    for (var _b = __values(Object.keys(__assign(__assign({}, values), obj))), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var key = _c.value;
                        var k = key;
                        if (obj[k] !== undefined) {
                            values[k] = obj[k];
                        }
                        else {
                            delete values[k];
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            });
            resetErrors();
        }, [resetErrors, setValues]);
        var setInitialValues = function (initialValues, isResetValues) {
            var e_5, _a;
            if (isResetValues === void 0) { isResetValues = true; }
            try {
                for (var _b = __values(Object.keys(initialValues)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    var k = key;
                    initialValuesRef.current[k] = initialValues[key];
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            if (isResetValues) {
                resetValues();
            }
        };
        var setValidateValues = function (key, value) {
            validateValuesRef.current[key] = value;
        };
        // 检查 Field 值是否变化
        var getDirtyState = useCallback(function (field) {
            var initialValues = initialValuesRef.current;
            var checkFieldKeys = [];
            var dirtyState = {};
            var checkIfFieldDirty = function (field) { return !equal(initialValues[field], values[field]); };
            if (typeof field === 'string') {
                checkFieldKeys = [field];
            }
            else if (Array.isArray(field)) {
                checkFieldKeys = field;
            }
            else if (field === undefined) {
                checkFieldKeys = Object.keys(values);
            }
            checkFieldKeys.forEach(function (field) {
                dirtyState[field] = checkIfFieldDirty(field);
            });
            return dirtyState;
        }, [initialValuesRef.current, values]);
        var setRules = function (field, value) {
            var e_6, _a;
            if (typeof field === 'string') {
                rules[field] = value;
            }
            else if (typeof field === 'object') {
                var data = field;
                try {
                    for (var _b = __values(Object.keys(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var key = _c.value;
                        rules[key] = data[key];
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        };
        var getRule = useCallback(function (field) {
            if (typeof field === 'string') {
                return rules[field];
            }
        }, [rules]);
        var getRules = useCallback(function (fields) {
            var e_7, _a;
            if (Array.isArray(fields)) {
                var tempRules = {};
                try {
                    for (var fields_3 = __values(fields), fields_3_1 = fields_3.next(); !fields_3_1.done; fields_3_1 = fields_3.next()) {
                        var key = fields_3_1.value;
                        tempRules[key] = rules[key];
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (fields_3_1 && !fields_3_1.done && (_a = fields_3.return)) _a.call(fields_3);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
                return tempRules;
            }
            else if (fields === undefined) {
                return __assign({}, rules);
            }
        }, [rules]);
        var removeRule = function (field) {
            delete rules[field];
        };
        var removeRules = function (fields) {
            var e_8, _a;
            try {
                for (var fields_4 = __values(fields), fields_4_1 = fields_4.next(); !fields_4_1.done; fields_4_1 = fields_4.next()) {
                    var field = fields_4_1.value;
                    delete rules[field];
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (fields_4_1 && !fields_4_1.done && (_a = fields_4.return)) _a.call(fields_4);
                }
                finally { if (e_8) throw e_8.error; }
            }
        };
        var validate = function (field, callback, isResetErr) {
            var option = validateOptionAdapter(field, callback, false, typeof callback === 'boolean' ? callback : isResetErr);
            return validateWithOption(option);
        };
        var validateAndScroll = function (field, callback, isResetErr) {
            var option = validateOptionAdapter(field, callback, true, typeof callback === 'boolean' ? callback : isResetErr);
            return validateWithOption(option);
        };
        var validateOptionAdapter = function (field, callback, isScroll, isResetErr) {
            var callbackFn = function () { };
            var defaultIsResetErr = true;
            var fields;
            var fieldsValue;
            if (typeof field === 'function') {
                callbackFn = field;
            }
            else if (typeof field === 'string') {
                fields = [field];
                defaultIsResetErr = false;
            }
            else if (Array.isArray(field)) {
                fields = field;
                defaultIsResetErr = false;
            }
            else if (typeof field === 'object') {
                fieldsValue = field;
                defaultIsResetErr = false;
            }
            if (typeof callback === 'function') {
                callbackFn = callback;
            }
            return {
                fields: fields,
                fieldsValue: fieldsValue,
                callback: callbackFn,
                isResetErr: isResetErr || defaultIsResetErr,
                isScroll: isScroll,
            };
        };
        var validateWithOption = function (option) {
            var _a, _b, e_9, _c, e_10, _d;
            if (option === void 0) { option = {}; }
            var field = option.field, fields = option.fields, fieldsValue = option.fieldsValue, excludeFields = option.excludeFields, _e = option.callback, callback = _e === void 0 ? function () { } : _e, _f = option.isResetErr, isResetErr = _f === void 0 ? false : _f, _g = option.isScroll, isScroll = _g === void 0 ? false : _g;
            // 避免 excludeFields 参数生效时，把当前保存的值和规则删掉
            var currentValidateValues = __assign({}, validateValues);
            var currentRules = __assign({}, rules);
            if (field) {
                currentValidateValues = (_a = {}, _a[field] = validateValues[field], _a);
                currentRules = (_b = {}, _b[field] = rules[field], _b);
            }
            else if (fields) {
                var tempValidateValues = {};
                var tempRules = {};
                try {
                    for (var fields_5 = __values(fields), fields_5_1 = fields_5.next(); !fields_5_1.done; fields_5_1 = fields_5.next()) {
                        var key = fields_5_1.value;
                        tempValidateValues[key] = validateValues[key];
                        tempRules[key] = rules[key];
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (fields_5_1 && !fields_5_1.done && (_c = fields_5.return)) _c.call(fields_5);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
                currentValidateValues = tempValidateValues;
                currentRules = tempRules;
            }
            else if (fieldsValue) {
                var tempRules = {};
                for (var key in fieldsValue) {
                    tempRules[key] = rules[key];
                }
                currentValidateValues = fieldsValue;
                currentRules = tempRules;
            }
            // 清除在 excludeFields 中的 field
            if (excludeFields) {
                try {
                    for (var excludeFields_1 = __values(excludeFields), excludeFields_1_1 = excludeFields_1.next(); !excludeFields_1_1.done; excludeFields_1_1 = excludeFields_1.next()) {
                        var key = excludeFields_1_1.value;
                        delete currentValidateValues[key];
                        delete currentRules[key];
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (excludeFields_1_1 && !excludeFields_1_1.done && (_d = excludeFields_1.return)) _d.call(excludeFields_1);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
            }
            // 清除 rule 为 undefined 的情况
            for (var key in currentRules) {
                if (!currentRules[key]) {
                    delete currentRules[key];
                }
            }
            var validator = new Validator(currentRules);
            var beforeErr = __assign({}, errors);
            return validator.validate(currentValidateValues, {}, function (errors) {
                var e_11, _a;
                if (errors) {
                    var errs_1 = isResetErr ? {} : beforeErr;
                    try {
                        for (var errors_1 = __values(errors), errors_1_1 = errors_1.next(); !errors_1_1.done; errors_1_1 = errors_1.next()) {
                            var error = errors_1_1.value;
                            errs_1[error.field] = error.message;
                        }
                    }
                    catch (e_11_1) { e_11 = { error: e_11_1 }; }
                    finally {
                        try {
                            if (errors_1_1 && !errors_1_1.done && (_a = errors_1.return)) _a.call(errors_1);
                        }
                        finally { if (e_11) throw e_11.error; }
                    }
                    setError(function () { return errs_1; });
                    if (isScroll) {
                        scrollWithErrors(errs_1);
                    }
                }
                else {
                    if (isResetErr) {
                        setError(function () { return ({}); });
                    }
                    else {
                        var removeErrorKeys_1 = (!field && !fields && !fieldsValue)
                            ? Object.keys(beforeErr)
                            : field
                                ? [field]
                                : (fields || Object.keys(fieldsValue));
                        // 对于未校验的字段，不清空错误
                        if (excludeFields) {
                            removeErrorKeys_1 = removeErrorKeys_1.filter(function (key) { return !excludeFields.includes(key); });
                        }
                        setError(function (errs) {
                            var e_12, _a;
                            try {
                                for (var removeErrorKeys_2 = __values(removeErrorKeys_1), removeErrorKeys_2_1 = removeErrorKeys_2.next(); !removeErrorKeys_2_1.done; removeErrorKeys_2_1 = removeErrorKeys_2.next()) {
                                    var field_1 = removeErrorKeys_2_1.value;
                                    delete errs[field_1];
                                }
                            }
                            catch (e_12_1) { e_12 = { error: e_12_1 }; }
                            finally {
                                try {
                                    if (removeErrorKeys_2_1 && !removeErrorKeys_2_1.done && (_a = removeErrorKeys_2.return)) _a.call(removeErrorKeys_2);
                                }
                                finally { if (e_12) throw e_12.error; }
                            }
                        });
                    }
                }
                callback(errors, values);
            })
                .then(function () { return ({ isPass: true }); })
                .catch(function (err) {
                var errors = err.errors, fields = err.fields;
                if (!errors && !fields) {
                    throw err;
                }
                return { errors: errors, fields: fields, isPass: !errors };
            });
        };
        return {
            values: values,
            setValues: setValues,
            resetValues: resetValues,
            removeValue: removeValue,
            removeValues: removeValues,
            setInitialValues: setInitialValues,
            initialValues: initialValuesRef.current,
            getDirtyState: getDirtyState,
            touchedState: touchedStateRef.current,
            setTouchedState: setTouchedState,
            setRules: setRules,
            getRule: getRule,
            getRules: getRules,
            removeRule: removeRule,
            removeRules: removeRules,
            validate: validate,
            validateAndScroll: validateAndScroll,
            validateWithOption: validateWithOption,
            errors: errors,
            setError: setError,
            removeError: removeError,
            removeErrors: removeErrors,
            resetErrors: resetErrors,
            setValidateValues: setValidateValues,
        };
    };
}
